import { IMachineClassificationAvailabilityConfig } from '../../modules/machine-inventory/interfaces/Machine.types';

export const CUSTOMER_GROUP_PREFIX = 'CUSTOMER#';
export const initialClassificationAvailabilityState: IMachineClassificationAvailabilityConfig = {
  hasAccessToRobots: false,
  hasAccessToGCD: false,
};
